import { render, staticRenderFns } from "./boreder-refound-explain.vue?vue&type=template&id=42611e54&scoped=true&"
import script from "./boreder-refound-explain.vue?vue&type=script&lang=js&"
export * from "./boreder-refound-explain.vue?vue&type=script&lang=js&"
import style0 from "./boreder-refound-explain.vue?vue&type=style&index=0&id=42611e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42611e54",
  null
  
)

export default component.exports